import { css, cx } from "@emotion/css"
import { Loading } from "components/Loading"
import { useI18n } from "providers/I18n"
import { SemiCircularProgressWithLabel } from "../SharedComponents/SemiCircularProgressWithLabel"
import { ProgressBarDot } from "../SharedComponents/ProgressBar"
import { NpsType } from "../../types"

const stylesWidgetStats = {
  container: css`
    display: flex;
    border-radius: 20px;
    background-color: var(--grey-opacity);
    align-items: center;
    flex-direction: column;
    z-index: 2;
    position: relative;
    height: 256px;
    width: 204px;
  `,
}

export type WidgetScaleType = {
  value?: number
  percentage: number
  nps?: NpsType
  isLoading?: boolean
  title?: string
}
export const WidgetScale = (props: WidgetScaleType) => {
  const { t } = useI18n()
  const { nps, title } = props

  return (
    <div className={stylesWidgetStats.container}>
      {props.isLoading ? (
        <Loading />
      ) : (
        <>
          <div style={{ position: "absolute", top: -10 }}>
            <SemiCircularProgressWithLabel
              percentage={props?.percentage}
              className={cx("HeadingH3Black")}
              title={title}
            />
          </div>
          <div style={{ position: "absolute", bottom: 15 }}>
            <ProgressBarDot
              percentage={props.percentage}
              title={t("revenue.responseRate")}
              label={nps?.responseRate + "%"}
              rate={nps?.responseRate ?? undefined}
              minRange="0%"
              maxRange="100%"
              range={100}
            />
            <div style={{ marginTop: 30 }}>
              <ProgressBarDot
                percentage={props.percentage}
                title={t("revenue.Delta")}
                label={nps?.delta?.toString()}
                rate={
                  !!nps?.delta || nps?.delta === 0
                    ? nps.delta! + 100
                    : undefined
                }
                minRange="-100"
                maxRange="100"
                range={200}
              />
            </div>
          </div>
        </>
      )}
    </div>
  )
}
